var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditMode24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 1.5,
  d: "M17 3.75v9.75M7 20.25V12.5m0-8.75V5.5m10 8.25a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 1 1 0-6.5Zm-10-1.5a3.25 3.25 0 1 1 0-6.5 3.25 3.25 0 1 1 0 6.5Z"
})));
export default SvgEditMode24;